angular
  .module('memberWhitelist')
  .component('memberWhitelist', {
    template: require('./member-whitelist.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function MemberWhitelistController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'members';
        $rootScope.menu = 'whitelist';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.coupons = {};
        this.total_count = 0;
        this.query = '';
        this.paging = (page) => {
          $resource(`${APIURL}/admin/whitelist`).get({ page: page - 1, q: $scope.query },
            (data) => {
              console.log(data);
              this.whitelists = data.whitelists;
              this.total_count = data.total_count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.addNumber = () => {
          const tel = prompt($translate.instant('전화번호를 입력해주세요.')); // eslint-disable-line
          if (!tel || tel.length < 1) {
            return;
          }

          const name = prompt($translate.instant('이름을 입력해 주세요.')); // eslint-disable-line
          if (!name || name.length < 1) {
            return;
          }

          $resource(`${APIURL}/admin/whitelist`).save({ tel, name }).$promise
            .then(() => {
              this.paging(1);
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.updateName = (whitelist) => {
          const name = prompt($translate.instant('이름을 입력해 주세요.')); // eslint-disable-line
          if (!name || name.length < 1) {
            return;
          }
          $resource(`${APIURL}/admin/whitelist/:id/name`, { id: whitelist.ID }).save({ name }).$promise
            .then(() => {
              whitelist.NAME = name;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.delete = (whitelist) => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/whitelist/:id`, { id: whitelist.ID }).delete().$promise
            .then(() => {
              this.paging(1);
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.paging(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/member-whitelist/member-whitelist.component.js